export const SHOP_MESSAGE_MAX_ATTACHMENTS = 4;
export const SHOP_MESSAGE_MAX_VIDEO_BYTES = 100 * 1024 * 1024;
export const SHOP_MESSAGE_MAX_OTHER_BYTES = 12 * 1024 * 1024;
export const SHOP_MESSAGE_ACCEPTED_TYPES = new Set([
  "image/jpeg", "image/png", "image/webp", "image/gif", "video/mp4", "video/webm",
  "audio/mpeg", "audio/mp4", "audio/wav", "audio/x-wav", "audio/ogg", "application/pdf",
]);

export function validateChatFiles(incoming: File[], existing: File[] = []): { accepted: File[]; rejected: { file: File; reason: string }[] } {
  const accepted: File[] = [];
  const rejected: { file: File; reason: string }[] = [];
  for (const file of incoming) {
    const maxBytes = file.type.startsWith("video/") ? SHOP_MESSAGE_MAX_VIDEO_BYTES : SHOP_MESSAGE_MAX_OTHER_BYTES;
    let reason = "";
    if (!SHOP_MESSAGE_ACCEPTED_TYPES.has(file.type)) reason = "Unsupported file type";
    else if (file.size <= 0 || file.size > maxBytes) reason = "File exceeds size limits or is empty";
    else if (existing.length + accepted.length >= SHOP_MESSAGE_MAX_ATTACHMENTS) reason = "Only 4 attachments per message";
    else if ([...existing, ...accepted].some((item) => item.name === file.name && item.size === file.size)) reason = "File already attached";
    if (reason) rejected.push({ file, reason }); else accepted.push(file);
  }
  return { accepted, rejected };
}

